import { useAtomValue } from 'jotai';
import { useMemo, useState } from 'react';
import { ColDef, GridApi, GridReadyEvent, GridState, ColumnState } from 'ag-grid-community';
import { Temporal } from 'temporal-polyfill';
import { COMPANY_VIEW_TYPE } from '../../../../data-models/view-config.data-model';
import { ViewModel } from '../../../../models/view.model';
import { ColumnMeta } from '../../../../types';
import { useSelectedCurrency } from '../../../../hooks/useSelectedCurrency';
import { AgTableWithBaseStyle } from '../../../../components/AgTable/AgTable2';
import { metricsResponseByDateAtom } from '../../state/MetricsStateJ';
import { columnsMetaState } from '../../state/ViewStateJ';
import { PredefinedColumns } from '../OverviewTable/columns/PredefinedColumns/PredefinedColumns';

export function OverviewTable2({ view }: { view: ViewModel }) {
  const [_gridApi, setGridApi] = useState<GridApi | null>(null);
  const { coldDefs, gridState, rowData } = useInitData(view);

  const onGridReady = (params: GridReadyEvent) => {
    setGridApi(params.api);
  };

  console.log('xxx coldDefs', coldDefs);
  console.log('xxx gridState', gridState.columnVisibility);

  console.log(
    'xxx gridState.columnVisibility!.hiddenColIds',
    gridState.columnVisibility!.hiddenColIds.indexOf('ActiveStatus')
  );

  return (
    <AgTableWithBaseStyle
      columnDefs={coldDefs}
      initialState={gridState}
      rowData={rowData}
      onGridReady={onGridReady}
      sideBar={{
        toolPanels: [
          {
            id: 'columns',
            labelDefault: 'Columns',
            labelKey: 'columns',
            iconKey: 'columns',
            toolPanel: 'agColumnsToolPanel',
            toolPanelParams: {
              suppressRowGroups: false,
              suppressValues: true,
              suppressPivots: true,
              suppressPivotMode: true,
              suppressColumnFilter: false,
              // suppressColumnSelectAll: true,
              // suppressColumnExpandAll: true,
            },
          },
        ],
      }}
    />
  );
}

function useInitData(view: ViewModel) {
  const columnsMeta = useAtomValue(columnsMetaState(COMPANY_VIEW_TYPE.RETURN_FORECAST));
  const { selectedCurrency } = useSelectedCurrency();
  const selectedDate = useMemo(() => {
    return view.asOfDate ? Temporal.PlainDate.from(view.asOfDate) : Temporal.Now.plainDateISO();
  }, [view.asOfDate]);
  const metricsResponse = useAtomValue(
    metricsResponseByDateAtom({ date: selectedDate, currency: selectedCurrency })
  );
  const { aggregation, columnPinning, ...gridState }: GridState = normalizeColumnMeta(columnsMeta, []);

  return {
    coldDefs: columnsMeta.filter((c) => c.visible === true).map(columnMetaToColDef),
    gridState,
    rowData: metricsResponse.isSuccess ? metricsResponse.data.metrics : [],
  };
}

function normalizeColumnMeta(columnsMeta: ColumnMeta[], columnStates: ColumnState[]): GridState {
  console.log(' xxx columnStates', columnStates);

  return {
    partialColumnState: true,
    version: '33.3.0',
  };
}

function columnMetaToColDef(columnMeta: ColumnMeta): ColDef {
  if (PredefinedColumns.columnsByView.RETURN_FORECAST_2[columnMeta.name]) {
    return PredefinedColumns.columnsByView.RETURN_FORECAST_2[columnMeta.name].getDefinition()!;
  }

  return {
    colId: columnMeta.name,
    keyCreator: () => columnMeta.path,
    field: columnMeta.path,
    headerName: columnMeta.displayName,
    // enableRowGroup: columnMeta.groupable,
    sortable: columnMeta.sortable,
    headerTooltip: columnMeta.description,
    // hide: !columnMeta.default,
    // lockVisible: columnMeta.visible,
    // lockPinned: true,
  };
}
